import { Component } from 'react';

import LocalStore from 'lib/LocalStore';

class AppState extends Component {
	state = {
	  loading: true,
	  collectionsOpen: false,
	  collections: [],
	  collection: null,
	  config: {},
	  pictograms: [],
	  buildings: [],
	  spaces: [],
	  brochures: [],
	  brochureType: LocalStore.get('brochureType'),
	  templates: {
	    loaded: false,
	    component: {},
	    layout: {},
	  },
	  brochure: null,

	  // USERS
	  user: null,
	  users: [],

	  // EDITOR
	  activeSlot: null,
	  pageListOpen: false,
	  controlsOpen: false,
	  generatePDFOpen: false,

	  browse: {
	    onlyShowBuildingsWithFreeSpaces: false,
	    type: LocalStore.get('browseType'),
	    sort: LocalStore.get('browseSort'),
	    activeFilters: [],
	    filters: {
	      contact: {
	        type: 'select',
	        name: 'header/filters/Contact',
	        hasSelected: false,
	        options: []
	      },
	      // city: {
	      // 	type: 'select',
	      // 	name: 'header/filters/City',
	      // 	hasSelected: false,
	      // 	options: []
	      // },
	      spaceType: {
	        type: 'select',
	        name: 'header/filters/SpaceType',
	        hasSelected: false,
	        options: []
	      },
	      region: {
	        type: 'select',
	        name: 'header/filters/Location',
	        hasSelected: false,
	        options: {
	          en: [],
	          fi: [],
	        }
	      },
	      area: {
	        type: 'range',
	        name: 'header/filters/Area',
	        open: false,
	        hasSelected: false,
	        range: {
	          min: 0,
	          max: 20000,
	          minSelected: false,
	          maxSelected: false,
	        }
	      },
	    }
	  }
	}
}

export default AppState
